import { combineReducers } from "redux";

import orders from "./orders";
import clients from "./clients";
import products from "./products";
import account from "./account";

export default combineReducers({
  orders,
  account,
  clients,
  products
});



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/redux/reducers/index.js